const footer = {
  listStyle: 'none',
  display: 'flex',
  justifyContent: 'space-between',
  margin: '12px 76px 12px 79px',
  padding: 0,
}

const galleryContainer = {
  width: '679px',
  minHeight: '340px',
  maxHeight: '680px',
  overflow: 'hidden',
}

const previewWrapper = {
  paddingBottom: '12px',
}

const singleAsset = {
  width: '680px',
  border: '1px solid white',
}

const styles = {
  footer,
  galleryContainer,
  previewWrapper,
  singleAsset,
}

export { styles }
